export default [
   
  /**New Jbseekers Route Start**/
  {
    // path: '/',
    path: '/jobseeker',
    name: 'jobseekers3',
    component: () => import('../components/website/jobseekers3/jobseekers.vue'),
    meta: { requiresAuth: false, hideForAuth:true , showFor:'admin'}
  },
  /**New Jbseekers Route End**/
]
